/** Formatação compartilhada pelas filas de aprovação. */

export const formatCurrency = (cents: number): string =>
    (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })

export const formatDate = (iso: string): string =>
    new Date(iso).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })

/**
 * Demonstrativo em PDF de um repasse agrupado, entre os anexos do lançamento.
 *
 * Procura pelo nome que `PayoutBatchService` grava; se o padrão mudar, cai no
 * primeiro PDF válido — melhor um anexo aproximado que nenhum botão. Anexo
 * rejeitado (recusado por um operador) fica de fora.
 */
export function findStatementAttachment(
    attachments?: Array<{ url: string; name: string; rejected?: boolean }> | null,
): { url: string; name: string } | null {
    if (!attachments?.length) return null

    const valid = attachments.filter(a => !a.rejected && a.url)
    const statement =
        valid.find(a => a.name?.startsWith('Demonstrativo de repasse')) ??
        valid.find(a => a.url.toLowerCase().endsWith('.pdf'))

    return statement ? { url: statement.url, name: statement.name } : null
}

export const formatDateTime = (iso?: string | null): string => {
    if (!iso) return '—'
    return new Date(iso).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}
